module.exports = __webpack_public_path__ + "static/media/platycleis_grisea_005_APA.c7ac0492.png";